import React from 'react'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import DrFarihasami_CV from '../../../assets/F_Social_science_Cv/Economics/DrFarihasami_CV.pdf'

import Footer from '../../../Components/Footer'
const Economics = () => {
  return (
    <>
    
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Economics</h2>
       
        <p>Faculty of Economics.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Fariha Sami </h4>
              <span> Assistant Professor Department of Economics</span>
              <p>Head Of Department Economics Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   farihasami@sbbwu.edu.pk   </p>
              <div className="social">
                <a href={DrFarihasami_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 

 
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>      
 
    </>
  )
}

export default Economics
